import React from 'react'
import { SvgIcon } from '@material-ui/core'

function ImportIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        id='Union'
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.99995 14.3379C4.55812 14.3379 4.19995 14.6961 4.19995 15.1379V19.1379C4.19995 19.5797 4.55812 19.9379 4.99995 19.9379H19C19.4418 19.9379 19.8 19.5797 19.8 19.1379V15.1379C19.8 14.6961 19.4418 14.3379 19 14.3379C18.5581 14.3379 18.2 14.6961 18.2 15.1379V18.3379H5.79995V15.1379C5.79995 14.6961 5.44178 14.3379 4.99995 14.3379Z'
      />
      <path
        id='Union_2'
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M12.4949 16.0704C12.2216 16.3437 11.7783 16.3437 11.505 16.0704L7.75498 12.3204C7.48161 12.047 7.48161 11.6038 7.75498 11.3304C8.02834 11.057 8.47156 11.057 8.74493 11.3304L11.3 13.8854L11.3 4.70039C11.3 4.31379 11.6134 4.00039 12 4.00039C12.3866 4.00039 12.7 4.31379 12.7 4.70039L12.7 13.8854L15.255 11.3304C15.5283 11.057 15.9716 11.057 16.2449 11.3304C16.5183 11.6038 16.5183 12.047 16.2449 12.3204L12.4949 16.0704Z'
      />
    </SvgIcon>
  )
}

export default ImportIcon
